<template>
    <div class="rcornersgrey mx-auto vstack" style="max-width:800px; overflow: initial;">
        <h1 class="text-center">{{title}}</h1>
        <div class="mt-3 required">
            <label id="dateRange" class="form-label mb-1 fw-bolder control-label">Stop Date Range:</label>
            <Datepicker :model-value="dateRangeFrom"
                    :format="dateFormat"
                    :clearable="false" 
                    required
                    :input-class-name="'form-control'" 
                    range
                    aria-labelledby="dateRange"
                    :enable-time-picker="false"
                    :max-date="new Date(Date.now())"
                    text-input
                    partial-range
                    prevent-min-max-navigation
                    :multi-calendars="2"
                    multi-calendars-solo
                    @update:model-value="handleDateRangeUpdate($event)"
                    :start-date="new Date(Date.now() - 2.6298e+9)"
                    :preset-ranges="presetRanges">
                    </Datepicker>
        </div>
        <div class="mt-3">
            <label class="form-label mb-1 fw-bolder">Optional Filters:</label>
            <b-filter-editor
            v-model="filterInfo" 
            ref="filterEditor" 
            :value="filterInfo" 
            :fields="filterableFields"
            @add-filter="addFilter"
                    @remove-filter="removeFilter"
                    @update-filter="updateFilter">
            </b-filter-editor>
        </div>        
        <div class="alert alert-danger mt-1" role="alert" v-show="errorText != ''">
            {{ errorText }}
        </div>
        <div class="actions w-100 mt-3 text-center hstack gap-2">
            <a :href="url" class="btn btn-primary " :class="{'disabled':dateRangeFrom.length == 0 || !areFiltersValid}" :disabled="dateRangeFrom.length == 0" target="_blank">Export</a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, defineProps, watch } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import BFilterEditor from "../BFilterEditor/BFilterEditor.vue";
import {
    BFilter,
    BFilterOptions,
    BFilterableField,
} from "../BFilterEditor/BFilterEditor.types";

const props = defineProps<{
    title:string,
    cancelUrl:string,
    submitUrl: string,
    exportUrl: string,
    filterableFields: BFilterableField[]
}>()

const emits = defineEmits(['submit','dateRangeUpdate','filterInfoUpdate']);

const dateFormat = "yyyy-MM-dd'";
const errorText = ref("");
const ori = ref("");
var dateRangeFrom = ref([] as Date[]);
var filterInfo = ref({ filters: [] } as BFilterOptions);
var now = new Date(Date.now());
const maxDate = `${now.getUTCFullYear()}-${now.getUTCMonth() + 1}-${now.getUTCDate()}`;

const areFiltersValid = computed(() => {
    return filterInfo.value.filters.every((it) => it.property && it.operation && it.value)
})

const presetRanges = ref([
    {label:"Last 3 Months", range: [getCurrentDateMinusNAmountOfMonths(3), new Date(Date.now())]}, 
    {label:"Last 6 Months", range: [getCurrentDateMinusNAmountOfMonths(6), new Date(Date.now())]}]
);

const url = computed(() => {
    return `${props.submitUrl}${props.exportUrl}`;    
});

function handleDateRangeUpdate(e) {
    if (!e) return;

    for(var i = 0; i < e.length; i++){
        now = new Date(Date.now());
        if(e[i] == null){
            e[i] = (i === 0) ? getCurrentDateMinusNAmountOfMonths(3): now;
        }
    }

    dateRangeFrom.value = e;
    return e;
}

function getCurrentDateMinusNAmountOfMonths(monthsToSubtract:number){
    let date = new Date();
    date.setMonth(date.getMonth() - monthsToSubtract);
    return date;
}

function addFilter() {
    var newFilter = {
        property: null,
        operation: null,
        value: null,
    } as BFilter;

    if (filterInfo.value) {
        filterInfo.value.filters = [...filterInfo.value.filters, newFilter];
    }
    emits('filterInfoUpdate',filterInfo.value);
}

function removeFilter(index: number) {
    if (filterInfo.value) {
        filterInfo.value.filters = filterInfo.value.filters.filter((it: any, ix: number) => ix != index);
    }
    emits('filterInfoUpdate',filterInfo.value);
}

function updateFilter(data: any) {
    if (data?.index > 0 && data?.filter != undefined) {
        filterInfo.value.filters[data.index] = data.filter;
    }
    emits('filterInfoUpdate',filterInfo.value);   
}

watch(
() => dateRangeFrom.value,
(val:any) => {
emits('dateRangeUpdate',val);
}
);

</script>